import { motion } from "framer-motion";
import { Mail } from "lucide-react";
import SectionHeader from "./SectionHeader";

const COUNCIL = [
  { name: "Rohita PR", role: "Convenor", contact: "rohita@harvestinternationalschool.in", motif: "R" },
  { name: "Agrim Prakash", role: "Head of Events", contact: "agrim_prakash@hisstudent.in", motif: "A" },
  { name: "VR Tharun", role: "Head of Events", contact: "tharun_v@hisstudent.in", motif: "T" },
  { name: "Anjali Bhatnagar", role: "Head of Equity", contact: "anjali_b@hisstudent.in", motif: "B" },
  { name: "Sukruth Naganur", role: "Head of Design", contact: "sukruth_n@hisstudent.in", motif: "S" },
  { name: "Arush Halder", role: "Head of Design", contact: "arush.halder@hisstudent.in", motif: "H" },
];

function Portrait({ m, idx }) {
  return (
    <motion.div
      initial={{ opacity: 0, y: 16 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, amount: 0.3 }}
      transition={{ duration: 0.5, delay: idx * 0.06 }}
      className="group text-center"
      data-testid={`team-member-${idx}`}
    >
      <div className="relative mx-auto w-28 h-28 sm:w-32 sm:h-32 md:w-36 md:h-36 rounded-full overflow-hidden border border-[#B8873B] bg-[#141414] grid place-items-center group-hover:border-[#E6C88A] group-hover:scale-105 transition-all duration-500">
        <span className="font-display text-5xl sm:text-6xl text-gold-gradient leading-none transition-transform duration-500 group-hover:-rotate-6">{m.motif}</span>
      </div>
      <div className="mt-4 sm:mt-5 font-display text-lg sm:text-xl text-marble">{m.name}</div>
      <div className="mt-1 text-[10px] tracking-[0.3em] uppercase text-[#B8873B]/80">{m.role}</div>
      <div className="mt-2 text-[11px] sm:text-xs text-white/45 flex items-center justify-center gap-1.5 break-all px-1">
        <Mail size={11} className="text-[#B8873B] shrink-0" />
        <span className="truncate">{m.contact}</span>
      </div>
    </motion.div>
  );
}

export default function Team() {
  return (
    <section id="team" data-testid="team-section" className="relative py-20 sm:py-24 md:py-32 bg-[#0A0A0A]">
      <div className="max-w-6xl mx-auto px-5 sm:px-6 lg:px-12">
        <SectionHeader
          eyebrow="Team"
          title={<><span className="text-marble">The </span><span className="italic text-gold-gradient">Council</span></>}
          subtitle="The architects of Tradella."
          align="center"
          testId="team-header"
        />

        <div className="mt-12 md:mt-16 grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-6 gap-y-10 gap-x-6">
          {COUNCIL.map((m, i) => (
            <Portrait key={m.name} m={m} idx={i} />
          ))}
        </div>
      </div>
    </section>
  );
}
